import {gql} from "@apollo/client";

const mentorIntroMessageQuery = gql`
    query MentorIntroMessageQuery(
        $mentorId: String
        $universitySlug: String
        $isDegreeTypesEnabled: Boolean = false
    ) {
        mentorIntroMessage(mentorId: $mentorId, universitySlug: $universitySlug) {
            introMessage {
                id
                text
                sender {
                    id
                    firstName
                    profilePhoto
                    accountRole
                    prospectWelcomeMessage
                    degreeLevel
                    degree {
                        id
                        name
                    }
                    degrees @include(if: $isDegreeTypesEnabled) {
                        degreeType
                        degree {
                            id
                            name
                        }
                    }
                    university {
                        id
                        name
                        isEnterprise
                    }
                    staffFields {
                        bio
                        department
                        role
                    }
                    year
                }
                chatGroupId
                created
                visible
            }
        }
    }
`;

export default mentorIntroMessageQuery;
